import { Link, useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { fileUrl } from "@/lib/api";

export default function Navbar() {
  const { settings } = useSettings();
  const location = useLocation();
  const logo = settings?.logo_path ? fileUrl(settings.logo_path) : null;
  const brandName = settings?.legal_business_name || "Maison Pilet";
  const tagline = settings?.tagline || "Beautiful things deserve another story.";

  return (
    <nav className="bg-ivory border-b border-taupe/40" data-testid="public-navbar">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-6 flex items-center justify-between gap-8">
        <Link to="/" className="flex items-center gap-4 group min-w-0" data-testid="brand-link">
          {logo ? (
            <img src={logo} alt={brandName} data-testid="brand-logo" className="h-12 w-12 object-contain border border-taupe/40 bg-linen p-1" />
          ) : (
            <img src="/maison-pilet-logo.png" alt={brandName} data-testid="brand-logo" className="h-14 w-11 object-contain" />
          )}
          <div className="hidden sm:block min-w-0">
            <p className="font-serif text-2xl lg:text-3xl lowercase tracking-tight text-charcoal leading-none truncate">
              {brandName.toLowerCase()}
            </p>
            <p className="editorial-label mt-1 truncate" data-testid="brand-tagline">{tagline.toLowerCase()}</p>
          </div>
        </Link>

        <div className="flex items-center gap-8 lg:gap-12">
          <Link to="/" className={`editorial-label hover:text-brass transition-colors ${location.pathname === "/" ? "text-brass" : ""}`} data-testid="nav-home">
            atelier
          </Link>
          <Link to="/shop" className={`editorial-label hover:text-brass transition-colors ${location.pathname.startsWith("/shop") ? "text-brass" : ""}`} data-testid="nav-shop">
            the edit
          </Link>
          <Link to="/admin/login" className="editorial-label hover:text-brass transition-colors" data-testid="nav-admin">
            studio
          </Link>
        </div>
      </div>
    </nav>
  );
}
